import type { DeliveryUrgency } from './types';

/** Билеты за доставку по GDD v2 (срочность × день ожидания до взятия). */
export function passRewardForDelivery(urgency: DeliveryUrgency, waitingDay: number): number {
  const day = Math.max(1, Math.floor(waitingDay));
  switch (urgency) {
    case 'regular':
      return 1;
    case 'important':
      return day === 1 ? 2 : 1;
    case 'urgent':
      if (day === 1) {
        return 3;
      }
      if (day === 2) {
        return 2;
      }
      return 1;
    default:
      return 1;
  }
}
